<template>
  <div>
    <el-dialog :title="isCreate ? '新增配置' : '修改配置'" center :visible="true" @close="onClose" :close-on-click-modal="false"
      :close-on-press-escape="false" :width="width">
      <el-form ref="form" :model="form" label-width="240px" size="mini">
        <el-divider v-if="!isCreate"><span
            style="font-size: smaller; color: red">修改以下配置项后需要到活动下一轮才会生效</span></el-divider>
        <el-form-item :hidden="isCreate" label="配置ID：" prop="confId">
          <el-input :disabled="!isCreate" v-model="form.confId" style="width: 80px"></el-input>
        </el-form-item>
        <el-form-item label="活动key：" prop="activityTemplateKey">
          <el-select allow-create :disabled="!isCreate" @change="typeValueChange" v-model="form.activityTemplateKey"
            filterable placeholder="请选择">
            <el-option v-for="item in templateKeys" :key="item.key"
              :label="item.isGlobal ? item.key + '（跨服）' : item.key" :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动类型：" prop="activityType">
          <el-input :disabled="!isCreate" v-model="form.activityType" style="width: 100px"></el-input>
        </el-form-item>
        <el-form-item label="简称：" prop="name">
          <el-input v-model="form.name" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item label="阶段：" prop="phase">
          <el-input v-model="form.phase" style="width: 100px"></el-input>
        </el-form-item>
        <el-form-item v-if="!templateKeys[form.activityTemplateKey]" label="跨服：" prop="isGlobal">
          <el-switch @change="changeGlobalBtn" v-model="form.isGlobal" active-color="#13ce66">
          </el-switch>
        </el-form-item>
        <el-form-item label="开始时间类型：" prop="startAtType">
          <!-- <el-input v-model="form.startAtType" style="width: 120px"></el-input> -->
          <el-select @change="startAtTypeChange" v-model="form.startAtType" filterable placeholder="请选择">
            <el-option v-for="item in startAtTypeSelectors" :key="item.value" :label="item.label" :value="item.value"
              :hidden="isGlobal && item.value == '1'">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="活动开始时间：" prop="startTime">
          <el-input v-model="form.startTime" style="width: 120px"></el-input>
        </el-form-item>
        <el-form-item label="持续时长（分钟）：" prop="keepMinutes">
          <el-input v-model="form.keepMinutes" style="width: 100px"></el-input>
        </el-form-item>
        <el-form-item v-if="
          startAtTypeSelectorsMaps[form.startAtType]
            ? startAtTypeSelectorsMaps[form.startAtType].isAbleSettingCycle
            : false
        " label="循环：" prop="isCycle">
          <el-switch v-model="form.isCycle" active-color="#13ce66"> </el-switch>
        </el-form-item>
        <el-form-item v-if="form.isCycle" label="循环间隔：" prop="isCycle">
          <el-input v-model.number="form.cycleInterval[0]" style="width: 80px"
            onkeyup="value=value.replace(/[^\d]/g, '')" placeholder="天"></el-input>&nbsp;天&nbsp;
          <el-input v-model.number="form.cycleInterval[1]" onkeyup="value=value.replace(/[^\d]/g, '')"
            style="width: 80px" placeholder="小时"></el-input>&nbsp;小时&nbsp;
          <el-input v-model.number="form.cycleInterval[2]" onkeyup="value=value.replace(/[^\d]/g, '')"
            style="width: 80px" placeholder="分钟"></el-input>&nbsp;分钟
        </el-form-item>
        <el-form-item label="玩法开始时间：" prop="playStartTime">
          <el-input v-model="form.playStartTime" style="width: 100px"></el-input>（相对活动开始时间的间隔，单位：分钟）
        </el-form-item>
        <el-form-item label="玩法持续时长（分钟）：" prop="playKeepTime">
          <el-input v-model="form.playKeepTime" style="width: 100px"></el-input>
        </el-form-item>
        <el-form-item label="配置生效时间：">
          <el-date-picker v-model="form.effectiveAt" type="datetime" :clearable="false" placeholder="选择日期"
            format="yyyy-MM-dd HH:mm:ss" value-format="timestamp">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="配置失效时间：">
          <el-date-picker v-model="form.expiredAt" type="datetime" :clearable="false" placeholder="选择日期"
            format="yyyy-MM-dd HH:mm:ss" value-format="timestamp">
          </el-date-picker>
        </el-form-item>       
        <el-divider v-if="!isCreate"><span style="font-size: smaller; color: red">修改以下配置项后会立即生效</span></el-divider>
        <el-form-item label="对哪些分区生效：">
          <el-input v-model="form.visibleToZonesFrom" style="width: 100px"></el-input>
          <span> - </span>
          <el-input v-model="form.visibleToZonesTo" style="width: 100px"></el-input>
        </el-form-item>         
        <el-form-item label="玩法类型：" prop="playType">
          <!-- <el-input v-model="form.playType" style="width: 100px"></el-input> -->
          <el-select v-model="form.playType" filterable placeholder="请选择">
            <el-option v-for="item in playTypeSelectors" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最后一轮玩法若时间不够就不开启：" prop="isNoNextPlayWhenTimeNotEnough">
          <el-switch v-model="form.isNoNextPlayWhenTimeNotEnough" active-color="#13ce66">
          </el-switch>（仅当为循环玩法时有效）
        </el-form-item>
        <el-form-item label="参数：" prop="parameter">
          <el-card class="box-card">
            <div v-if="hasUI" style="margin-bottom: 10px">
              使用JSON模式：<el-switch v-model="isShowJson" active-color="#13ce66" @change="toJsonSwitch">
              </el-switch>
            </div>
            <div v-if="
              !isShowJson && form.activityTemplateKey == typeEumn.autoMail
            ">
              <AutoMail :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson && form.activityTemplateKey == typeEumn.atm
            ">
              <ATM :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson && form.activityTemplateKey == typeEumn.taskActivity
            ">
              <TaskActivity :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson &&
              form.activityTemplateKey == typeEumn.breakThroughLevel
            ">
              <BreakThroughLevel :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson &&
              form.activityTemplateKey == typeEumn.levelLeaderBoard
            ">
              <LevelLeaderBoard :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson &&
              form.activityTemplateKey ==
              typeEumn.cumulativeRechargeOfLimitTime
            ">
              <CumulativeRechargeOfLimitTime :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson && form.activityTemplateKey == typeEumn.weekly
            ">
              <Weekly global :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson && form.activityTemplateKey == typeEumn.zoneWeekly
            ">
              <Weekly :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson &&
              form.activityTemplateKey == typeEumn.accumulatedRechargeRebate
            ">
              <AccumulatedRechargeRebate :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson &&
              form.activityTemplateKey == typeEumn.rechargeRebate
            ">
              <RechargeRebate :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson &&
              form.activityTemplateKey ==
              typeEumn.foreverAccumulatedRechargeRebate
            ">
              <ForeverAccumulatedRechargeRebate :parameter="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else-if="
              !isShowJson &&
              form.activityTemplateKey == typeEumn.collectItems
            ">
              <CollectItems :parameters="form.parameter" @updated="upsertParameter" />
            </div>
            <div v-else>
              <el-input placeholder="参数必须是JSON格式（可以不填）" type="textarea" rows="15" v-model="form.parameter"></el-input>
            </div>
          </el-card>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");

import AutoMail from "./activity_parameter_template/AutoMail";
import ATM from "./activity_parameter_template/ATM";
import TaskActivity from "./activity_parameter_template/TaskActivity";
import BreakThroughLevel from "./activity_parameter_template/BreakThroughLevel";
import LevelLeaderBoard from "./activity_parameter_template/LevelLeaderBoard";
import CumulativeRechargeOfLimitTime from "./activity_parameter_template/CumulativeRechargeOfLimitTime";
import Weekly from "./activity_parameter_template/Weekly";
import AccumulatedRechargeRebate from "./activity_parameter_template/AccumulatedRechargeRebate";
import RechargeRebate from "./activity_parameter_template/RechargeRebate";
import ForeverAccumulatedRechargeRebate from "./activity_parameter_template/ForeverAccumulatedRechargeRebate";
import CollectItems from "./activity_parameter_template/CollectItems";

// 本弹窗名称
const DialogName = "EditActivityTemplateDialog";

export default {
  data() {
    return {
      isGlobal: false,
      isCreate: true,
      form: {
        name: "",
        phase: 1,
        effectiveAt: new Date().getTime(),
        expiredAt: new Date().getTime() + 3600 * 1000 * 24 * 365 * 100,
        parameter: "",
        isCycle: false,
        cycleInterval: [0, 0, 0],
        visibleToZonesFrom: 1,
        visibleToZonesTo: 10000000,
      },
      startAtTypeSelectors: [],
      playTypeSelectors: [],
      startAtTypeSelectorsMaps: {},

      isShowJson: false,
      width: "761px",
      templateKeys: {},
      typeEumn: {
        autoMail: "自动邮件",
        atm: "心愿ATM",
        taskActivity: "任务活动",
        breakThroughLevel: "冲关",
        levelLeaderBoard: "关卡排行榜",
        cumulativeRechargeOfLimitTime: "限时累充",
        weekly: "每周活动",
        zoneWeekly: "单服每周活动",
        accumulatedRechargeRebate: "累充返利",
        rechargeRebate: "充值返利",
        foreverAccumulatedRechargeRebate: "永久累充返利",
        collectItems: "道具收集",
      },
      dataVerification: async () => {
        return;
      },
    };
  },
  components: {
    AutoMail,
    ATM,
    TaskActivity,
    BreakThroughLevel,
    LevelLeaderBoard,
    CumulativeRechargeOfLimitTime,
    Weekly,
    AccumulatedRechargeRebate,
    RechargeRebate,
    ForeverAccumulatedRechargeRebate,
    CollectItems,
  },
  computed: {
    hasUI() {
      switch (this.form.activityTemplateKey) {
        case this.typeEumn.autoMail:
        case this.typeEumn.atm:
        case this.typeEumn.taskActivity:
        case this.typeEumn.breakThroughLevel:
        case this.typeEumn.levelLeaderBoard:
        case this.typeEumn.cumulativeRechargeOfLimitTime:
        case this.typeEumn.weekly:
        case this.typeEumn.zoneWeekly:
        case this.typeEumn.accumulatedRechargeRebate:
        case this.typeEumn.rechargeRebate:
        case this.typeEumn.foreverAccumulatedRechargeRebate:
        case this.typeEumn.collectItems:
          return true;
      }
      return false;
    },
  },
  async created() {
    await this.loadActivityKey();
    await this.loadParam();
    let value = this.$dialogutil.getData(DialogName);
    this.isCreate = value.isCreate;
    if (!this.isCreate) {
      this.form = value.entry;
    }

    this.typeValueChange(this.form.activityTemplateKey);
  },

  methods: {
    toJsonSwitch(e) {
      if (e && this.form.parameter) {
        let tmpObj = JSON.parse(this.form.parameter);
        this.form.parameter = JSON.stringify(tmpObj, null, "    ");
      }
    },
    typeValueChange(e) {
      this.isGlobal = false;
      if (this.templateKeys[e]) {
        this.isGlobal = this.templateKeys[e].isGlobal;
      }
      switch (e) {
        case this.typeEumn.autoMail: {
          this.width = "961px";
          break;
        }
        case this.typeEumn.taskActivity: {
          this.width = "1350px";
          break;
        }
        case this.typeEumn.breakThroughLevel: {
          this.width = "1061px";
          break;
        }
        case this.typeEumn.levelLeaderBoard: {
          this.width = "1061px";
          break;
        }
        case this.typeEumn.cumulativeRechargeOfLimitTime: {
          this.width = "1061px";
          break;
        }
        case this.typeEumn.weekly: {
          this.width = "1061px";
          break;
        }
        case this.typeEumn.zoneWeekly: {
          this.width = "1061px";
          break;
        }
        case this.typeEumn.accumulatedRechargeRebate: {
          this.width = "961px";
          break;
        }
        case this.typeEumn.rechargeRebate: {
          this.width = "1061px";
          break;
        }
        case this.typeEumn.foreverAccumulatedRechargeRebate: {
          this.width = "961px";
          break;
        }
        case this.typeEumn.collectItems: {
          this.width = "1061px";
          break;
        }
        default: {
          this.width = "761px";
        }
      }
    },
    async upsertParameter(param, dataVerification) {
      this.form.parameter = param;
      this.dataVerification = dataVerification;
    },
    /**
     * 加载活动类型
     */
    async loadActivityKey() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryActivityTemplateKey`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.keys || [];

      for (let entry of listInResponse) {
        this.templateKeys[entry.key] = entry;
      }
    },

    changeGlobalBtn(e) {
      this.isGlobal = e;
    },

    async startAtTypeChange(val) {
      this.form.isCycle = false;
    },

    /**
     * 提交表单
     */
    async submit() {
      if (!this.isShowJson) {
        let v = await this.dataVerification();
        if (v) {
          this.$message.error(v.errMsg);
          return;
        }
      }

      this.form.name = this.form.name.trim();
      if (this.form.name.length == 0) {
        this.$message.error("名称不能为空");
        return;
      }
      this.form.activityTemplateKey = this.form.activityTemplateKey.trim();
      if (this.form.activityTemplateKey.length == 0) {
        this.$message.error("活动key不能为空");
        return;
      }

      if (
        this.form.effectiveAt > this.form.expiredAt ||
        this.form.effectiveAt < new Date().getTime()
      ) {
        try {
          // 弹确认框
          await this.$confirm(`按照当前配置将无法开启这个活动，确认吗？`);
        } catch (error) {
          return;
        }
      }

      if (this.isCreate) {
        this.add();
      } else {
        this.update();
      }
    },

    /**
     * 新增
     */
    async add() {
      try {
        // 弹确认框
        await this.$confirm(`确认新增配置？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/addActivityTemplate`,
            { entry: this.form },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        // 弹确认框
        await this.$confirm(`添加成功`);

        // 关闭当前对话框
        this.onClose();
      } catch (e) { }
    },

    /**
     * 修改
     */
    async update() {
      try {
        // 弹确认框
        await this.$confirm(`确认修改配置？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/updateActivityTemplate`,
            { entry: this.form },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onClose();
      } catch (e) { }
    },

    /**
     * 查询配置
     */
    async loadParam() {
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryActivityParam`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let startAtTypeSelects = resData.data.startAtTypeSelects;
      for (let item of startAtTypeSelects) {
        this.startAtTypeSelectors.push({
          label: item.label,
          value: Number(item.value),
        });

        this.startAtTypeSelectorsMaps[item.value] = item;
      }
      let playTypeSelects = resData.data.playTypeSelects;
      for (let item of playTypeSelects) {
        this.playTypeSelectors.push({
          label: item.label,
          value: Number(item.value),
        });
      }
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
  },
};
</script>